const related = {
  // ===== 共通 =====
  'related.common.official': '公式サイトを見る',
  'related.common.externalNote': '※リンク先は別サイトです（別ウィンドウで開きます）',
  'related.common.backToHub': '関連事業の一覧へ戻る',
  'related.common.backToTop': 'ページ上部へ戻る',
  'related.common.otherTitle': 'ほかの関連事業',
  'related.common.otherSubtitleEn': 'Other related organizations',

  // ===== 関連事業ハブ /related =====
  'related.hub.hero.home': 'ホーム',
  'related.hub.hero.about': 'アカデミーについて',
  'related.hub.hero.current': '関連事業',
  'related.hub.hero.title': '関連事業のご案内',
  'related.hub.hero.titleEn': 'RELATED ORGANIZATIONS',
  'related.hub.hero.lead':
    '日本執事アカデミーは、一般社団法人全日本執事協会を運営母体として、執事文化を支えるいくつかの組織・ブランドと連携しています。',
  'related.hub.hero.imgAlt': '格式ある邸宅で控える執事のイメージ',

  'related.hub.intro.label': 'OUR NETWORK',
  'related.hub.intro.title': '執事文化を支える協会グループ',
  'related.hub.intro.subtitleEn': 'The organizations behind the academy',
  'related.hub.intro.para1':
    '日本執事アカデミーの教育は、単独で成り立っているわけではありません。運営母体である一般社団法人全日本執事協会を中心に、執事文化を社会へ伝える発信ブランド、そして実際の執事サービスを担うブランドが連携し、学びから実務までを一つの流れとしてつないでいます。',
  'related.hub.intro.para2':
    'このページでは、日本執事アカデミーと関わりの深い関連事業――全日本執事協会、執事ベル、THE BUTLER、株式会社ファミリーロマンス、石井裕一オフィシャルサイト――について、それぞれの役割と、日本執事アカデミーとのつながりをご紹介します。執事という仕事の全体像を知る手がかりとしてご覧ください。',

  'related.hub.cards.label': 'RELATED ORGANIZATIONS',
  'related.hub.cards.title': '五つの関連事業',
  'related.hub.cards.subtitleEn': 'Five related organizations',

  'related.hub.card.association.name': '一般社団法人 全日本執事協会',
  'related.hub.card.association.role': '育成・認定・法人研修',
  'related.hub.card.association.desc':
    '執事の育成と協会認定資格の発行、法人研修を担う団体。日本執事アカデミーの運営母体として、執事という職業の社会的価値を高める活動を続けています。',
  'related.hub.card.association.imgAlt': '応接室でモーニングコートを着用し出迎えの姿勢で佇む執事',

  'related.hub.card.bell.name': '執事ベル',
  'related.hub.card.bell.role': '情報発信ブランド',
  'related.hub.card.bell.desc':
    '全日本執事協会 三代目頭取・石井裕一のオフィシャルブランド。YouTube「執事ベル」などを通じて、本物の執事の姿とおもてなしの心を広く発信しています。',
  'related.hub.card.bell.imgAlt': '全日本執事協会 三代目頭取・石井裕一が正装で撮影されたポートレート',

  'related.hub.card.butler.name': 'THE BUTLER',
  'related.hub.card.butler.role': '執事サービスの窓口',
  'related.hub.card.butler.desc':
    '全日本執事協会が運営する執事サービス。ご家庭からビジネス、VVIP対応まで、暮らしとおもてなしを包括的に支える窓口です。日本執事アカデミー修了生が力を発揮する現場でもあります。',
  'related.hub.card.butler.imgAlt': '高級レジデンスで給仕する執事のイメージ',

  'related.hub.card.fr.name': '株式会社ファミリーロマンス',
  'related.hub.card.fr.role': '三代目頭取・石井裕一が創業した家族代行サービス',
  'related.hub.card.fr.desc':
    '全日本執事協会 三代目頭取・石井裕一が代表取締役を務める家族代行サービスの会社。2004年の創業から、家族・恋人・友人代行など幅広い代行サービスを全国で提供しています。',
  'related.hub.card.fr.imgAlt': '株式会社ファミリーロマンスのオフィスフロアの様子',

  'related.hub.card.ishii.name': '石井裕一オフィシャルサイト',
  'related.hub.card.ishii.role': '三代目頭取・石井裕一の俳優・実業家としての活動',
  'related.hub.card.ishii.desc':
    '全日本執事協会 三代目頭取・石井裕一の公式サイト。俳優として映画『Family Romance, LLC』に主演した活動や、ハーバード大学講演でのガラス賞受賞などを紹介しています。',
  'related.hub.card.ishii.imgAlt': '石井裕一のポートレート',

  'related.hub.card.viewInternal': '詳しく見る',
  'related.hub.card.viewExternal': '公式サイト',

  'related.hub.rel.label': 'RELATIONSHIP',
  'related.hub.rel.title': '日本執事アカデミーと関連事業のつながり',
  'related.hub.rel.subtitleEn': 'How we are connected',
  'related.hub.rel.body':
    '一般社団法人全日本執事協会が運営母体となり、その教育部門が日本執事アカデミーです。協会三代目頭取のオフィシャルブランドが執事ベル、協会が提供する執事サービスがTHE BUTLER――学びと発信と実務が、一つの協会のもとでつながっています。',

  'related.hub.cta.title': '執事の学びに興味をお持ちの方へ',
  'related.hub.cta.body':
    'コースや協会認定資格、法人研修について、ご不明な点はお気軽にお問い合わせください。資料は無料でお送りしています。',
  'related.hub.cta.courses': 'コースを見る',
  'related.hub.cta.contact': 'お問い合わせ',
  'related.hub.lastUpdated': '最終更新: 2026年7月5日',

  // ===== 全日本執事協会 /related/butler-association =====
  'related.assoc.hero.home': 'ホーム',
  'related.assoc.hero.parent': '関連事業',
  'related.assoc.hero.current': '全日本執事協会',
  'related.assoc.hero.title': '一般社団法人 全日本執事協会',
  'related.assoc.hero.titleEn': 'THE JAPAN BUTLER ASSOCIATION',
  'related.assoc.hero.lead':
    '執事の育成と協会認定資格の発行、法人研修を通じて、執事という職業の社会的価値向上に取り組む一般社団法人です。',
  'related.assoc.hero.imgAlt': '格式のある応接室でモーニングコートを着用し佇む執事の様子',

  'related.assoc.about.label': 'ABOUT',
  'related.assoc.about.title': '全日本執事協会とは',
  'related.assoc.about.subtitleEn': 'What is the Japan Butler Association?',
  'related.assoc.about.para1':
    '一般社団法人全日本執事協会は、執事という職業の社会的価値を高めることを目的に、執事の育成・認定・法人研修を担う団体です。日本執事アカデミーは、この協会が運営する教育部門にあたります。',
  'related.assoc.about.para2':
    '協会の活動は育成だけにとどまりません。所定の課程を修了し実技試験に合格した人材へ協会認定資格を授与することで育成した執事の質を保証し、あわせて執事の接遇スキルに基づくビジネスマナー研修を企業向けに提供することで、執事の作法をより広い現場で活かせるものへとつなげています。',
  'related.assoc.about.para3':
    '執事という仕事を、限られた世界だけの特別な職業としてではなく、明確な基準のもとで評価される専門職として社会に位置づけていくこと——それが、協会が育成・認定・研修を一貫して担う理由です。',

  'related.assoc.points.label': 'OUR ROLE',
  'related.assoc.points.title': '協会が担う4つの役割',
  'related.assoc.points.subtitleEn': 'What the Association does',
  'related.assoc.points.1.title': '執事の育成',
  'related.assoc.points.1.desc':
    '日本執事アカデミーを通じて、エッセンシャルからマスターまで体系立てたカリキュラムで執事を育成しています。',
  'related.assoc.points.2.title': '協会認定資格の発行',
  'related.assoc.points.2.desc':
    '所定の課程を修了し実技試験に合格した方に協会認定のバトラー資格を授与し、育成した人材の質を保証しています。',
  'related.assoc.points.3.title': '法人研修の提供',
  'related.assoc.points.3.desc':
    '執事の接遇スキルに基づくビジネスマナー研修を、企業の現場に合わせて出張・来校いずれの形式でも提供しています。',
  'related.assoc.points.4.title': '執事という職業の社会的価値向上',
  'related.assoc.points.4.desc':
    '育成・認定・研修を一貫して担うことで、執事という仕事の基準を明確にし、専門職としての社会的地位の向上に取り組んでいます。',

  'related.assoc.role.label': 'RELATIONSHIP WITH TJBA',
  'related.assoc.role.title': '日本執事アカデミーとのつながり',
  'related.assoc.role.subtitleEn': 'Connection with the academy',
  'related.assoc.role.para1':
    '日本執事アカデミーは、一般社団法人全日本執事協会が運営する教育部門です。執事の育成・認定・法人研修を通じて職業の社会的価値を高めるという協会の理念が、アカデミーの育成方針の土台になっています。',
  'related.assoc.role.para2':
    '協会の三代目頭取を務めるのが、執事ベルこと石井裕一です。学びの場である日本執事アカデミー、発信を担う執事ベル、そして執事サービスを担うTHE BUTLER——これらはいずれも、一般社団法人全日本執事協会のもとでつながっています。',

  'related.assoc.service.label': 'FOR THOSE SEEKING BUTLER SERVICE',
  'related.assoc.service.title': '執事サービスをご利用になりたい方へ',
  'related.assoc.service.body1':
    '協会が運営する執事サービスが THE BUTLER です。ご家庭からビジネス、VVIP対応まで、暮らしとおもてなしを包括的に支えています。',
  'related.assoc.service.body2':
    'サービスの詳しい内容やご依頼については、THE BUTLER の公式サイトをご覧ください。',
  'related.assoc.service.cta': 'THE BUTLER の詳細を見る',
  'related.assoc.service.url': 'thebutler.jp',

  'related.assoc.official.title': '一般社団法人全日本執事協会 公式サイト',
  'related.assoc.official.body': '協会の活動内容や組織概要など、より詳しい情報は公式サイトをご覧ください。',
  'related.assoc.official.url': 'www.butler-association.jp',
  'related.assoc.lastUpdated': '最終更新: 2026年7月5日',

  // ===== 執事ベル /related/butler-bell =====
  'related.bell.hero.home': 'ホーム',
  'related.bell.hero.parent': '関連事業',
  'related.bell.hero.current': '執事ベル',
  'related.bell.hero.title': '執事ベル',
  'related.bell.hero.titleEn': 'BUTLER BELL',
  'related.bell.hero.lead': '全日本執事協会 三代目頭取・石井裕一のオフィシャル情報発信ブランド。',
  'related.bell.hero.imgAlt': '全日本執事協会 三代目頭取・石井裕一が正装で撮影されたポートレート',

  'related.bell.about.label': 'ABOUT',
  'related.bell.about.title': '執事ベルとは',
  'related.bell.about.subtitleEn': 'Who is Butler Bell?',
  'related.bell.about.para1':
    '執事ベルは、一般社団法人全日本執事協会の三代目頭取を務める石井裕一のオフィシャルブランドです。長年にわたり国内外のお客様に執事として仕えてきた経験をもとに、本物の執事の姿と、日本ならではのおもてなしの心を、広く社会に伝える活動を続けています。',
  'related.bell.about.para2':
    'YouTube「執事ベル」チャンネルをはじめとする情報発信では、華やかなサービスの表側だけでなく、その裏側にある執事の規律や所作、心構えまでを丁寧に紹介しています。マナーやおもてなしを学びたい方、執事という仕事に関心のある方に向けて、実用的で奥行きのある内容を届けています。',
  'related.bell.about.para3':
    '執事ベルの活動は、執事文化を現代の暮らしに合わせて伝え直す試みでもあります。伝統を重んじながら、動画やSNSといった現代のメディアを通じて、執事の魅力を次の世代へとつないでいます。',

  'related.bell.points.label': 'HIGHLIGHTS',
  'related.bell.points.title': '執事ベルの活動',
  'related.bell.points.subtitleEn': 'What Butler Bell does',
  'related.bell.points.1.title': '執事文化の発信',
  'related.bell.points.1.desc':
    'YouTube「執事ベル」チャンネルなどを通じて、執事の日常や所作、おもてなしの心を発信しています。',
  'related.bell.points.2.title': 'マナー・教養の紹介',
  'related.bell.points.2.desc':
    'テーブルマナーや立ち居振る舞いなど、暮らしにも活かせる執事の教養を、わかりやすく伝えています。',
  'related.bell.points.3.title': '執事文化の現代化',
  'related.bell.points.3.desc':
    '伝統的な執事の在り方を、現代のメディアを通じて次の世代へとつなぐ取り組みを続けています。',

  'related.bell.role.label': 'RELATIONSHIP WITH TJBA',
  'related.bell.role.title': '日本執事アカデミーとのつながり',
  'related.bell.role.subtitleEn': 'Connection with the academy',
  'related.bell.role.para1':
    '執事ベルこと石井裕一は、日本執事アカデミーの運営母体である全日本執事協会の三代目頭取です。協会が掲げる「世界水準の執事を育成する」という理念のもと、日本執事アカデミーの育成方針にも、その執事観が息づいています。',
  'related.bell.role.para2':
    '執事ベルが発信する「本物のおもてなし」の考え方は、日本執事アカデミーで学ぶ所作や心構えとも深くつながっています。動画や記事で執事の世界に触れてから、体系立てて学びたいと考える方にとって、日本執事アカデミーはその受け皿となる場所です。',

  'related.bell.official.title': '執事ベル 公式サイト',
  'related.bell.official.body': '執事ベルの活動や発信内容の詳細については、公式サイトをご覧ください。',
  'related.bell.official.url': 'butlerbell.jp',
  'related.bell.lastUpdated': '最終更新: 2026年7月3日',

  // ===== THE BUTLER /related/the-butler =====
  'related.butler.hero.home': 'ホーム',
  'related.butler.hero.parent': '関連事業',
  'related.butler.hero.current': 'THE BUTLER',
  'related.butler.hero.title': 'THE BUTLER（執事サービス）',
  'related.butler.hero.titleEn': 'THE BUTLER',
  'related.butler.hero.lead':
    '一般社団法人全日本執事協会が運営する、執事によるおもてなしのサービスです。ご相談・お申し込みは公式サイト THE BUTLER が窓口となっています。',
  'related.butler.hero.imgAlt': '高級レジデンスで給仕する執事のイメージ',

  'related.butler.about.label': 'ABOUT',
  'related.butler.about.title': 'THE BUTLER とは',
  'related.butler.about.subtitleEn': 'What is THE BUTLER?',
  'related.butler.about.para1':
    'THE BUTLER は、日本執事アカデミーの運営母体でもある一般社団法人全日本執事協会が運営する執事サービスです。英国式執事の規律と品格に、日本ならではの細やかな礼節を重ねた、フルオーダー型のおもてなしを提供しています。',
  'related.butler.about.para2':
    '単なる家事の代行ではなく、お客様が本来向き合うべき仕事や家族、休息に集中できる環境そのものを整えることを大切にしています。主人が言葉にする前に必要を察し、静かに寄り添う――そうした先回りの奉仕が、THE BUTLER の執事サービスの本質です。',

  'related.butler.services.label': 'SERVICES',
  'related.butler.services.title': '主なサービス内容',
  'related.butler.services.subtitleEn': 'What the butlers provide',
  'related.butler.services.1.title': 'ハウスキーピング',
  'related.butler.services.1.desc':
    '住居の管理や調理、洗濯、買い出し、お子様の送迎・見守りなど、暮らしの基盤を静かに整えます。',
  'related.butler.services.2.title': 'ビジネスフォロー',
  'related.butler.services.2.desc':
    'スケジュール管理や資料作成、会議の準備、送迎など、多忙な日々のビジネスを支えます。',
  'related.butler.services.3.title': 'イベント・接遇',
  'related.butler.services.3.desc':
    '来賓のお出迎えやお見送り、給仕、空間演出など、特別な日のおもてなしを担います。',
  'related.butler.services.4.title': 'バトラーコンシェルジュ',
  'related.butler.services.4.desc':
    'VVIP・富裕層のお客様に向けた、オーダーメイドのサービスをご用意しています。',

  'related.butler.role.label': 'RELATIONSHIP WITH TJBA',
  'related.butler.role.title': '日本執事アカデミーとのつながり',
  'related.butler.role.subtitleEn': 'Connection with the academy',
  'related.butler.role.para1':
    'THE BUTLER と日本執事アカデミーは、いずれも一般社団法人全日本執事協会を母体としています。日本執事アカデミーが育成した執事が、品格あるサービスを届ける現場のひとつが THE BUTLER です。',
  'related.butler.role.para2':
    '学びと実務が同じ協会のもとでつながっていることは、日本執事アカデミーの教育が机上のものではなく、実際のサービスの現場を見据えて設計されていることを意味します。執事の仕事を将来の選択肢として考える方にとって、その先にある姿を具体的に描ける関係です。',

  'related.butler.official.title': 'THE BUTLER 公式サイト（ご相談・お申し込みの窓口）',
  'related.butler.official.body': '執事サービスのご相談・お申し込みは、THE BUTLER の公式サイトが窓口です。プランや料金の詳細もあわせてご案内しています。',
  'related.butler.official.url': 'thebutler.jp',
  'related.butler.lastUpdated': '最終更新: 2026年7月5日',

  // ===== ファミリーロマンス /related/family-romance =====
  'related.fr.hero.home': 'ホーム',
  'related.fr.hero.parent': '関連事業',
  'related.fr.hero.current': 'ファミリーロマンス',
  'related.fr.hero.title': '株式会社ファミリーロマンス',
  'related.fr.hero.titleEn': 'FAMILY ROMANCE',
  'related.fr.hero.lead':
    '一般社団法人全日本執事協会 三代目頭取・石井裕一が代表取締役を務める、家族代行サービスの会社です。',
  'related.fr.hero.imgAlt': '株式会社ファミリーロマンスのオフィスフロアの様子',

  'related.fr.about.label': 'ABOUT',
  'related.fr.about.title': '株式会社ファミリーロマンスとは',
  'related.fr.about.subtitleEn': 'What is Family Romance Inc.?',
  'related.fr.about.para1':
    '株式会社ファミリーロマンスは、2004年に石井裕一が創業した会社です。当時24歳だった石井は、シングルマザーの友人から幼稚園受験の相談を受けたことをきっかけに代行サービスを始め、「家族代行」という、それまで日本に存在しなかった概念を形にしました。',
  'related.fr.about.para1Link': 'family-romance.com',
  'related.fr.about.para2':
    '以来20年以上にわたり、家族代行・恋人代行・友人代行から結婚式代理出席、お詫び代行まで、幅広い代行サービスを全国で提供しています。全国に5,000名以上の登録スタッフを擁し、依頼者一人ひとりの事情に寄り添う体制を整えています。',
  'related.fr.about.para2Link': '代行サービスの詳細を見る',

  'related.fr.points.label': 'HIGHLIGHTS',
  'related.fr.points.title': 'ファミリーロマンスの4つの特徴',
  'related.fr.points.subtitleEn': 'What Family Romance does',
  'related.fr.points.1.title': '家族代行のパイオニア',
  'related.fr.points.1.desc':
    '2004年の創業以来、家族・恋人・友人代行から結婚式代理出席まで、日本に存在しなかった「代行サービス」という概念を形にしてきました。',
  'related.fr.points.2.title': '5,000名以上のスタッフ体制',
  'related.fr.points.2.desc':
    '全国に5,000名以上の登録スタッフを擁し、依頼者一人ひとりの事情に合わせて対応する体制を整えています。',
  'related.fr.points.3.title': '国際的な映画への出演',
  'related.fr.points.3.desc':
    '代表・石井裕一は、ヴェルナー・ヘルツォーク監督の映画『Family Romance, LLC』に本人役で主演し、第72回カンヌ国際映画祭の監督週間で上映されました。',
  'related.fr.points.3.link': '映画情報はこちら',
  'related.fr.points.4.title': '徹底した情報管理',
  'related.fr.points.4.desc':
    '全スタッフとNDA（秘密保持契約）を締結し、業務で知り得た情報の漏洩を防止。20年以上にわたり情報漏洩ゼロの実績を築いています。',

  'related.fr.role.label': 'RELATIONSHIP WITH TJBA',
  'related.fr.role.title': '日本執事アカデミーとのつながり',
  'related.fr.role.subtitleEn': 'Connection with the academy',
  'related.fr.role.para1':
    '一般社団法人全日本執事協会の三代目頭取を務める石井裕一は、株式会社ファミリーロマンスの創業者兼代表取締役でもあります。執事という専門職を育成する協会の運営と、家族代行という別事業の経営――形は異なりますが、いずれも「人と人のつながりを支える」という石井の一貫した姿勢が土台にあります。',
  'related.fr.role.para2':
    '日本執事アカデミーが大切にする「相手の望みを察し、静かに支える」という執事の心構えは、ファミリーロマンスが20年以上にわたり培ってきた、依頼者に寄り添う姿勢とも通じるものです。',
  'related.fr.role.para2Link': 'ファミリーロマンス公式サイトを見る',

  'related.fr.official.title': '株式会社ファミリーロマンス 公式サイト',
  'related.fr.official.body': '代行サービスの詳しい内容やご依頼については、公式サイトをご覧ください。',
  'related.fr.official.url': 'family-romance.com',
  'related.fr.lastUpdated': '最終更新: 2026年7月5日',

  'related.fr.gallery.workOffice': 'ファミリーロマンスのオフィスで打ち合わせをするスタッフ',
  'related.fr.gallery.philosophyBonds': 'ファミリーロマンスが大切にする人と人とのつながりを表すイメージ',
  'related.fr.gallery.svcFamily': 'ファミリーロマンスが提供する家族代行サービスのイメージ',

  // ===== 石井裕一オフィシャルサイト /related/ishii-yuichi =====
  'related.ishii.hero.home': 'ホーム',
  'related.ishii.hero.parent': '関連事業',
  'related.ishii.hero.current': '石井裕一オフィシャルサイト',
  'related.ishii.hero.title': '石井裕一 オフィシャルサイト',
  'related.ishii.hero.titleEn': 'YUICHI ISHII OFFICIAL SITE',
  'related.ishii.hero.lead':
    '一般社団法人全日本執事協会 三代目頭取・石井裕一の、俳優・実業家としての活動を紹介する公式サイトです。',
  'related.ishii.hero.imgAlt': '石井裕一のポートレート',

  'related.ishii.about.label': 'ABOUT',
  'related.ishii.about.title': '石井裕一オフィシャルサイトとは',
  'related.ishii.about.subtitleEn': 'What is the Yuichi Ishii official site?',
  'related.ishii.about.para1':
    '石井裕一オフィシャルサイトは、一般社団法人全日本執事協会 三代目頭取であり、執事ベルとして情報発信も行う石井裕一の、俳優・実業家としてのプロフィールをまとめた公式サイトです。1981年生まれ。株式会社ファミリーロマンスの創業者兼代表取締役として、2004年から家族代行サービスを手がけてきました。',
  'related.ishii.about.para1Link': 'getstage.com',
  'related.ishii.about.para2':
    '2019年には、ドイツの映画監督ヴェルナー・ヘルツォークの映画『Family Romance, LLC』に本人役で主演し、第72回カンヌ国際映画祭の監督週間で上映されました。同年、ハーバード大学のカンファレンスに招かれて講演を行い、ガラス賞を受賞しています。',
  'related.ishii.about.para2Link': '俳優としての活動を見る',
  'related.ishii.about.para3': '著書に『人間レンタル屋』（鉄人社、2019年）があります。',

  'related.ishii.points.label': 'HIGHLIGHTS',
  'related.ishii.points.title': '石井裕一の4つの活動',
  'related.ishii.points.subtitleEn': "What Yuichi Ishii does",
  'related.ishii.points.1.title': '俳優としての活動',
  'related.ishii.points.1.desc':
    '2019年公開の映画『Family Romance, LLC』（ヴェルナー・ヘルツォーク監督）に本人役で主演。第72回カンヌ国際映画祭の監督週間で上映されました。',
  'related.ishii.points.2.title': '実業家としての活動',
  'related.ishii.points.2.desc':
    '株式会社ファミリーロマンスの創業者兼代表取締役。2004年から家族代行サービスを展開し、「家族代行」という日本に存在しなかった概念を社会に広めました。',
  'related.ishii.points.3.title': 'ハーバード大学での講演',
  'related.ishii.points.3.desc':
    '2019年、Harvard Global Health & Leadership Conferenceに招かれて講演し、家族代行サービスの社会的意義について語り、ガラス賞を受賞しました。',
  'related.ishii.points.4.title': '著書',
  'related.ishii.points.4.desc':
    '『人間レンタル屋』（鉄人社、2019年）を執筆。代行サービスの現場で見てきた、人と人のつながりについてまとめています。',

  'related.ishii.role.label': 'RELATIONSHIP WITH TJBA',
  'related.ishii.role.title': '日本執事アカデミーとのつながり',
  'related.ishii.role.subtitleEn': 'Connection with the academy',
  'related.ishii.role.para1':
    '石井裕一は、日本執事アカデミーの運営母体である一般社団法人全日本執事協会の三代目頭取であり、執事ベルとしてYouTubeなどを通じて執事文化を発信しています。俳優・実業家としての活動の詳細は、公式サイトでご覧いただけます。',
  'related.ishii.role.para1Link': 'getstage.com',
  'related.ishii.role.para2':
    '国内外のメディアに取り上げられてきた石井のこれまでの歩みは、日本執事アカデミーが目指す「執事という職業を、明確な基準のもとで評価される専門職として社会に位置づける」という理念とも重なります。',
  'related.ishii.role.para2Link': '詳しいプロフィールを見る',

  'related.ishii.official.title': '石井裕一 オフィシャルサイト',
  'related.ishii.official.body': '俳優・実業家としての活動やプロフィールの詳細は、公式サイトをご覧ください。',
  'related.ishii.official.url': 'getstage.com',
  'related.ishii.lastUpdated': '最終更新: 2026年7月5日',

  'related.ishii.gallery.harvard': 'ハーバード大学の講演で家族代行サービスについて語る石井裕一',
  'related.ishii.gallery.frLlc01': '映画『Family Romance, LLC』に本人役で主演する石井裕一のスチール',
  'related.ishii.gallery.frLlc02': '映画『Family Romance, LLC』の撮影シーンのスチール',
};

export default related;
